import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children, superOnly = false }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="p-10 text-sm text-muted-foreground">Loading…</div>;
    if (!user) return <Navigate to={`/app/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
    if (superOnly && !user.is_super_admin) return <Navigate to="/app/dashboard" replace />;
    return children;
}
